<template>
    <div class="loaderContainer" v-if="loading">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
    </div>
</template>

<style lang="scss" scoped>
    .loaderContainer {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
</style>


<script>
    export default {
        props: {
            loading: Boolean,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/LoaderComponent.vue